// function isValidDomain(origin, customDomain = '') {
//   // Domain and api domain
//   const params = new URLSearchParams(window.location.search);
//   const env = params.get('env') || '';
// let allowedOrigins = [
//     'https://www.gevme.com',
//     'https://showcase-dev.gevme.com',
//     'https://showcase-dev.gev.me',
//     'https://showcase.gev.me',
//     'https://live.gev.me',
//     'https://live-dev.gevme.com',
//     'https://live.gevme.com',
//     'https://admin.gevme.com',
//     'https://admin.gev.me',
//     'https://admin-dev.gevme.com',
//   ];

//   if (
//     (process.env.NODE_ENV === 'development' ||
//       process.env.NODE_ENV === 'LOCAL') &&
//     env === 'localhost'
//   ) {
//     allowedOrigins.push('http://localhost:3001');
//   }

//   if (customDomain) {
//     allowedOrigins.push(customDomain);
//   }

//   return allowedOrigins.some((domain) => origin === domain);
// }

function handleMessageAgenda(event, iframeId) {
  try {
    let dataObj = JSON.parse(event.data);

    if (dataObj.eventType === 'height') {
      var agendaFrame = document.getElementById(`${dataObj.eventData.frameId}`);
      agendaFrame.style.height = dataObj.eventData.height;
    }

    if (dataObj.action === 'agenda-location') {
      document.getElementById(iframeId).contentWindow.postMessage(
        JSON.stringify({
          eventData: dataObj,
        }),
        '*'
      );
    }

    switch (dataObj.eventType) {
      case 'bookmark':
        document.getElementById(iframeId).contentWindow.postMessage(
          JSON.stringify({
            eventData: dataObj.eventData,
          }),
          '*'
        );
        break;
      case 'listenerAttached':
        document
          .getElementById(`GevmeAgenda${dataObj?.id}`)
          .contentWindow.postMessage(
            JSON.stringify({
              action: 'gevme-json',
              data: JSON.stringify(window.GEVME),
            }),
            '*'
          );
        break;
      default: {
      }
    }
  } catch (error) {
    console.error(error.message);
  }
}
class GevmeAgenda extends HTMLElement {
  constructor() {
    super();
  }
  attachAgendaMessageEvent(iframeId) {
    window.addEventListener('message', (e) => {
      if (window.isValidDomain && window.isValidDomain(e.origin, window?.GEVME?.setting?.customDomain)) {
        handleMessageAgenda(e, iframeId);
      }
    });
  }
  connectedCallback() {
    var iframe = document.createElement('iframe'),
      redirectBaseURI = `${
        window?.GEVME?.setting?.customDomain || process.env.TEMPLATE_APP_DOMAIN
      }/widgets`,
      objset = {},
      iframeSrc = '',
      isContentBlock = false,
      frameHeight = '400px',
      settings = this.getAttribute('settings'),
      preview = this.getAttribute('preview'),
      fullpagepreview = this.getAttribute('fullpagepreview'),
      slug = this.getAttribute('slug'),
      identifier = settings,
      iframeId = `GevmeAgenda${settings}`;
    try {
      // if JSON.parse fails then settings is a string not an object
      // in this case use the old format
      objset = JSON.parse(settings);
      iframeSrc =
        redirectBaseURI + '/agenda?s=' + encodeURI(JSON.stringify(objset));
      frameHeight = objset && objset.height ? objset.height : '400px';
    } catch (error) {
      // in this case blockid was passed in settings attribute
      isContentBlock = true;
    }

    if (isContentBlock) {
      try {
        const passedId = settings;
        const showcaseBlocks = Object.values(
          window.GEVME.livepage.showcaseblocks
        );
        const agendaData = showcaseBlocks.find(({ id }) => id === passedId);
        if (!agendaData) throw new Error('block not found');

        if (agendaData.blockHeight && agendaData.blockHeight !== 'fit-content')
          frameHeight = agendaData.blockHeight;

        iframeSrc =
          `${redirectBaseURI}/agenda?frameId=${iframeId}&companyId=${window?.GEVME?.project?.companyId}&projectId=${window?.GEVME?.project?.id}&livePageId=${window?.GEVME?.livepage?.id}&blockId=${passedId}` +
          `${window?.GEVME?.isPreview ? '&isPreview=true' : ''}` +
          `${identifier ? `&id=${identifier}` : ''}` +
          (fullpagepreview
            ? `&previewInXP=${
                fullpagepreview === 'true' || fullpagepreview === 'undefined'
                  ? 'false'
                  : 'true'
              }`
            : '') +
          `&slug=${window?.GEVME?.livepage?.slug}`;
      } catch (error) {
        console.error(error);
      }
    }
    iframe.id = iframeId;
    iframe.name = 'GevmeAgenda';
    iframe.title = 'Gevme Agenda';
    iframe.sandbox =
      'allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation allow-downloads allow-modals allow-presentation allow-same-origin';
    iframe.allowFullScreen = true;
    iframe.seamless = true;
    iframe.loading = 'lazy';
    iframe.frameBorder = '0';
    iframe.referrerPolicy = 'no-referrer';
    iframe.src = iframeSrc;
    iframe.onload = function () {
      this.contentWindow.postMessage(
        JSON.stringify({
          action: 'gevme-json',
          data: JSON.stringify(window.GEVME),
        }),
        '*'
      );
    };
    iframe.style = `display: flex; width: ${
      objset && objset.width ? objset.width : '100%'
    }; height: 100%; overflow: hidden; margin: auto;`;
    // ${frameHeight} !important
    this.attachAgendaMessageEvent(iframeId);
    this.append(iframe);
  }
}
window.customElements.define('gevme-agenda', GevmeAgenda);
